import { useMemo } from "react";
import { parseLiveModelIdsResponse, type CatalogModelIdRow } from "@dosia/shared";
import { orgLiveModelIdsPath } from "./api-paths.js";
import { useApiQuery } from "./useApiQuery.js";

/**
 * 组织详情各页「已下线」标记（N-88）用的网关现行模型 id 集合：`GET /api/organizations/:orgCode/live-model-ids`，
 * 服务端读的是下发时对账（admin-portal `buildBootstrapPayload`）同一个 `LiveModelCatalogProvider`。组织管理员与
 * 平台超管都能读（org-scoped 只读面），只回 base id + 是否 live + 取数时间。
 *
 * 返回 `undefined` = 这次没有 live 清单（请求失败、服务端标 unavailable、形状不对），调用方**一个下线标记都
 * 不出**——与下发「清单不可达原样下发、绝不误剔」同口径；拿空清单判会把每一条在用的配置都标成已下线。
 * 形状校验单源 shared `parseLiveModelIdsResponse`。
 */
export function useRetiredMarksCatalog(orgCode: string): readonly CatalogModelIdRow[] | undefined {
  const q = useApiQuery<unknown>(orgLiveModelIdsPath(orgCode), [orgCode]);
  return useMemo(() => (q.error === null ? parseLiveModelIdsResponse(q.data) : undefined), [q.data, q.error]);
}
